/* Preserve localized product HTML while grouping its top-level headings. */
(function () {
  function enhance(scope) {
    scope.querySelectorAll('[data-dm-description-accordion]:not([data-dm-accordion-ready])').forEach(function (root) {
      var fallback = root.querySelector('[data-dm-description-fallback]');
      var source = root.querySelector('[data-dm-description-source]');
      if (!fallback || !source) return;
      var nodes = Array.from(source.childNodes);
      if (!nodes.some(function (node) { return node.nodeType === 1 && node.tagName === 'H2'; })) return;
      var groups = [];
      var group = { heading: null, nodes: [] };
      nodes.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'H2') {
          if (group.heading || group.nodes.some(function (item) { return item.textContent.trim(); })) groups.push(group);
          group = { heading: node, nodes: [] };
        } else {
          group.nodes.push(node);
        }
      });
      if (group.heading || group.nodes.some(function (item) { return item.textContent.trim(); })) groups.push(group);
      var fragment = document.createDocumentFragment();
      groups.forEach(function (item) {
        var details = document.createElement('details');
        details.className = 'dm-product-details__item';
        var summary = document.createElement('summary');
        if (item.heading) {
          if (item.heading.id) details.id = item.heading.id;
          while (item.heading.firstChild) summary.appendChild(item.heading.firstChild);
        } else {
          summary.appendChild(document.createTextNode(fallback.querySelector('summary').textContent.trim()));
        }
        var toggle = document.createElement('span');
        toggle.className = 'dm-product-details__toggle';
        toggle.setAttribute('aria-hidden', 'true');
        summary.appendChild(toggle);
        var body = document.createElement('div');
        body.className = 'dm-product-details__content rte caption';
        item.nodes.forEach(function (node) { body.appendChild(node); });
        details.appendChild(summary);
        details.appendChild(body);
        fragment.appendChild(details);
      });
      root.replaceChildren(fragment);
      root.setAttribute('data-dm-accordion-ready', 'true');
    });
    revealAnchor();
  }
  function revealAnchor() {
    if (!window.location.hash) return;
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
    var target = document.getElementById(id);
    if (!target || !target.closest('.dm-product-details')) return;
    var node = target;
    while (node) {
      if (node.tagName === 'DETAILS') node.open = true;
      node = node.parentElement;
    }
    target.scrollIntoView({ block: 'start' });
  }
  enhance(document);
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  window.addEventListener('hashchange', revealAnchor);
})();
